import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { NavLink } from "react-router-dom";

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", background: "#3bbba3"}}
        onClick={onClick}
      />
    );
  }
  
  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", background: "#3bbba3" }}
        onClick={onClick}
      />
    );
  }


function ImageSlider() {
    let settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        cssEase: "linear",
        responsive: [{
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
             breakpoint: 400,
             settings: {
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
             }
          }]
    }
    return (
        <Slider {...settings}>

            <div className="card-wrapper">
            <NavLink to="/athletisme" className="activites">
                <div className="card">

                    <div className="card-image">

                        <img className="img-responsive" src="../img/activites/athletismeactivite.jpg"  alt="" />
                    </div>
                   
                    <div className="details">
                    </div>
                </div>
                <h3 className="activites-title">Athlétisme</h3>
</NavLink>
            </div>

            <div className="card-wrapper">
            <NavLink to="/cross_training" className="activites">
                <div className="card">
                    <div className="card-image">
                    <img className="img-responsive" src="../img/activites/crosstrainingactivite.jpg"  alt="" />
                    </div>
                   
                    <div className="details">
                    </div>
                </div>
                <h3 className="activites-title">Cross training</h3>
</NavLink>
            </div>

            <div className="card-wrapper">
            <NavLink to="/fitdance" className="activites">
                <div className="card">
                    <div className="card-image">
                    <img className="img-responsive" src="../img/activites/fitdanceactivite.jpg"  alt="" />
                    </div>
                   
                    <div className="details">
                    </div>
                </div>
                <h3 className="activites-title">Fitdance</h3>
</NavLink>
            </div>

            <div className="card-wrapper">
            <NavLink to="/pilates" className="activites">
                <div className="card">
                    <div className="card-image">
                    <img className="img-responsive" src="../img/activites/pilateactivite.jpg"  alt="" />
                    </div>
                   
                    <div className="details">
                    </div>
                </div>
                <h3 className="activites-title">Pilates</h3>
</NavLink>
            </div>
            <div className="card-wrapper">
            <NavLink to="/cardio_boxing" className="activites">   <div className="card">
                    <div className="card-image">
                    <img className="img-responsive" src="../img/activites/cardioboxingactivite.jpg"  alt="" />
                    </div>
                   
                    <div className="details">
                    </div>
                </div>
                <h3 className="activites-title">Cardio boxing</h3>
</NavLink>
            </div>
        </Slider>
    )
}

export default ImageSlider